enum DistributionType {
  none = "now",
  on3Days = "3days",
  on7Days = "7days",
  on14Days = "14days",
  on30Days = "30days",
  on45Days = "45days",
  on60Days = "60days",
}

export const distributionTypeAsString = (
  distributionType: DistributionType
): string => {
  switch (distributionType) {
    case DistributionType.none:
      return "Pas de répartition (prise de contact immédiate)";
    case DistributionType.on3Days:
      return "Répartition sur 3 jours";
    case DistributionType.on7Days:
      return "Répartition sur 7 jours";
    case DistributionType.on14Days:
      return "Répartition sur 14 jours";
    case DistributionType.on30Days:
      return "Répartition sur 1 mois";
    case DistributionType.on45Days:
      return "Répartition sur 1 mois et demi";
    case DistributionType.on60Days:
      return "Répartition sur 2 mois";
    default:
      return "";
  }
};

export default DistributionType;
